import { StrictMode } from "react";

import ReactDOM from "react-dom/client";
import { initializeApp } from "firebase/app";
import { MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";

import { App } from "@components/App/App";

import reportWebVitals from "./reportWebVitals";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";

import "dayjs/locale/de";

import "./i18n";

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

const firebaseConfig = {
  apiKey: "AIzaSyBfsFKZkbWzkNATqb7Ylt8rdxhvB00j5ig",
  authDomain: "cologne-pride-76cc1.firebaseapp.com",
  databaseURL:
    "https://cologne-pride-76cc1-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "cologne-pride-76cc1",
  storageBucket: "cologne-pride-76cc1.appspot.com",
  messagingSenderId: "1000134200183",
  appId: "1:1000134200183:web:a75fa206973c0965036f72",
  measurementId: "G-C1ESRRVRHV",
};

initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <StrictMode>
    <MantineProvider
      withGlobalStyles
      withNormalizeCSS
      theme={{
        primaryColor: "purple",
        colors: {
          // @ts-ignore
          purple: Array(10)
            .fill(1)
            .map(() => "#8361DF"),
        },
      }}
    >
      <NotificationsProvider>
        <App />
      </NotificationsProvider>
    </MantineProvider>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
